module.exports = __webpack_public_path__ + "img/home-prize-5.ea046e75.png";